import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";


export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserapp: builder.query({
            query: () => `b2g/eco-admin/user/waste-category/unit`,
            transformResponse: responseData => {
                return responseData?.data;
            },
            providesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        addNewUserapp: builder.mutation({
            query: body => ({
                url: '/b2g/eco-admin/user/waste-category/unit',
                method: 'POST',
                body: body
            }),
            invalidatesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        deleteUserApp: builder.mutation({
            query: id => ({
                url: `/b2g/eco-admin/user/waste-category/unit/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        editUserApp: builder.mutation({
            query: payLoad => ({
                url: `/b2g/eco-admin/user/waste-category/unit`,
                method: 'PATCH',
                body: payLoad
            }),
            invalidatesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
    })
})

export const {
    useGetUserappQuery,
    useAddNewUserappMutation,
    useDeleteUserAppMutation,
    useEditUserAppMutation,
} = extendedApiSlice
